import { SET_IS_MOBILE } from "../store/modules/CoreSlice";
import { store } from "../store";
import { Layout } from "./Constants";

export function resizeListener() {
    const update = () => {
        const isMobile =
            window.innerWidth <= Layout.MOBILE_VIEWPORT_WIDTH ||
            window.innerHeight <= Layout.MOBILE_VIEWPORT_HEIGHT;
        store.dispatch(SET_IS_MOBILE(isMobile));
    };

    update();
    window.addEventListener("resize", update);

    return () => {
        window.removeEventListener("resize", update);
    };
}
